module.exports = __webpack_public_path__ + "img/04-3-1实施方法论.aac76626.svg";